import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-layout-layout-top-panel-6-icon',
  templateUrl: './layout-layout-top-panel-6.component.html'
})
export class LayoutLayoutTopPanel6Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
